import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { authGuard } from './guards/auth.guard';
import { hasPermissionGuard } from './guards/has-permission.guard';

const routes: Routes = [
  {
    path: '403', component: UnauthorizedComponent
  },
  {
    path: '404', component: PageNotFoundComponent
  },

  {
    path: 'pub',
    loadChildren: () => import('./pages/modules/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: '', component: HomeComponent,
    canActivate: [authGuard], 
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'profile',
        loadChildren: () => import('./pages//modules/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./pages//modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [hasPermissionGuard]
      },
    
      {
        path: 'user-clbtt-mng',
        loadChildren: () => import('./pages/modules/user-clbtt/user-clbtt.module').then(m => m.UserClbttModule),
        canActivate: [hasPermissionGuard]
      },
       {
        path: 'user-clbtt-khoi-mng',
        loadChildren: () => import('./pages/modules/user-clbtt-khoi/user-clbtt-khoi.module').then(m => m.UserClbttKhoiModule),
        canActivate: [hasPermissionGuard]
      },
       {
        path: 'sp-clb',
        loadChildren: () => import('./pages/modules/support-clb/support-clb.module').then(m => m.SupportClbModule),
        canActivate: [hasPermissionGuard]
      } ,
      {
        path: 'sp-k',
        loadChildren: () => import('./pages/modules/support-khoi/support-khoi.module').then(m => m.SupportKhoiModule),
        canActivate: [hasPermissionGuard]
      },
      {
        path: 'ld-k',
        loadChildren: () => import('./pages/modules/ld-khoi/ld-khoi.module').then(m => m.LdKhoiModule),
        canActivate: [hasPermissionGuard]
      },
    ]
  },
  {
    path: '**', component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
